<template>
  <div>
    <v-card>
      <v-container fluid>
        <v-text-field name="message" id="message" v-model.trim="message" rows="2" textarea required></v-text-field>
        <v-card-actions>
          <v-btn class="success--text darken-1" flat @click.prevent="sendMessage">send</v-btn>
          <file-modal ref="file_modal"></file-modal>
        </v-card-actions>
      </v-container>
    </v-card>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase'
import FileModal from './FileModal'
import uuidV4 from 'uuid/V4'

export default {
  name: 'message-form',
  components: { FileModal },
  data () {
    return {
      message: '',
      errors: [],
      storageRef: firebase.storage().ref(),
      uploadTask: null,
      uploadState: null
    }
  },
  computed: {
    ...mapGetters(['currentChannel', 'currentUser', 'isPrivate']),
    uploadLabel () {
    }
  },
  methods: {
    sendMessage () {
      if (this.currentChannel !== null) {
        if (this.message.length > 0) {
          this.$parent
            .getMessageRef()
            .child(this.currentChannel.id)
            .push()
            .set(this.createMessage())
            .then(() => {})
            .catch(error => {
              this.errors.push(error.message)
            })

          this.message = ''
        }
      }
    },
    createMessage (fileUrl = null) {
      let message = {
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        user: {
          name: this.currentUser.displayName,
          avatar: this.currentUser.photoURL,
          id: this.currentUser.uid
        }
      }
      if (fileUrl == null) {
        message['content'] = this.message
      } else {
        message['image'] = fileUrl
      }
      return message
    },
    uploadFile (file, metadata) {
      if (file === null) return false

      let pathToUpload = this.currentChannel.id
      let ref = this.$parent.getMessageRef()
      let filePath = this.getPath() + '/' + uuidV4() + '.jpg'

      this.uploadTask = this.storageRef.child(filePath).put(file, metadata)
      this.uploadState = 'uploading'

      this.uploadTask.on(
        'state_changed',
        snap => {},
        error => {
          this.errors.push(error.message)
          this.uploadState = 'error'
          this.uploadTask = null
        },
        () => {
          this.uploadState = 'done'
          this.$refs.file_modal.resetForm()

          let fileUrl = this.uploadTask.snapshot.downloadURL
          this.sendFileMessage(fileUrl, ref, pathToUpload)
        }
      )
    },
    sendFileMessage (fileUrl, ref, pathToUpload) {
      ref
        .child(pathToUpload)
        .push()
        .set(this.createMessage(fileUrl))
        .then(() => {
          this.$nextTick(() => {
          })
        })
        .catch(error => {
          this.errors.push(error.message)
        })
    },
    openFileModal () {

    },
    getPath () {
      if (this.isPrivate) {
        return 'tchat/private/' + this.currentChannel.id
      } else {
        return 'tchat/public'
      }
    }
  },
  beforeDestroy () {
    if (this.uploadTask !== null) {
      this.uploadTask.cancel()
      this.uploadTask = null
    }
  }
}

</script>

<style lang="stylus">
.input-group__details
  min-height: 0px
</style>



// WEBPACK FOOTER //
// MessageForm.vue?44d4a66a